<template>
<div class="upload-box" style="position: relative;">
    <span style="position: relative; z-index: 1;">
        <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('gallery_image_update')">
        {{ getEntityByLanguage(item, 'image')  ? __('media.change-from') : __('media.select-from' ) }}
    </a>
    </span>

    <img v-if="getEntityByLanguage(item, 'image') && !form.from_media_library_id"
    class="absolute-opacity-image" :src="getEntityByLanguage(item, 'image')" />

    <img class="absolute-opacity-image" v-if="form.from_media_library_id && form.item_id == item.id" :src="form.loaded_file_path">

</div>

<div class="mt-3 mb-3">
    <button @click="cancelEdit" class="btn btn-sm btn-black">Cancel</button>
</div>

<div class="my-5">
    <h5 class="text-white text-lg font-bold mb-3">Title</h5>
    <input
           @change="handleChange" name="title"
           class="input-black" type="text" :value="getEntityByLanguage(item, 'title')">

    <h5 class="text-white text-lg font-bold mb-3">Description</h5>
    <textarea
              class="input-black" @change="handleChange" name="description" rows="7"
              :value="getEntityByLanguage(item, 'description')"></textarea>
    <div class="flex justify-center pb-2">
        <button v-if="form.processing" class="btn btn-sm btn-gradient mr-2"><Spinner/></button>
        <button v-if="!form.processing" @click.prevent="updateItem" class="btn btn-sm btn-gradient mr-2">Update</button>

        <button v-if="delete_item_form.processing" class="btn btn-sm btn-black mr-2"><Spinner/></button>
        <button v-if="getEntityByLanguage(item, 'image') && !delete_item_form.processing"
            @click.prevent="deleteItem(item)" class="btn btn-sm btn-black">
            <i class="trash"></i>Delete
        </button>
    </div>
</div>
</template>

<script>
import Spinner from '@/UI/Spinner';
import { __ } from '@/locale';
export default {
	components: {
        Spinner
	},
	props: [
		'item',
		'getEntityByLanguage',
        'cancelEdit',
        'deleteItem',
        'delete_item_form',
        'changeUploadBoxState',
        'form',
        'updateItem',
        'handleChange'
	],
	data(){
		return{
			__
		}
	}
}
</script>